import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import { AppContext } from '../../context/AppContext';
import getLoopIsDisabled from '../../utils/getLoopIsDisabled';
import DisabledWarning from '../DisabledWarning';

const EnergyFlowSavingLayoutContainer = ({ children }) => {
  const { userDetails, showSimulationMode } = useContext(AppContext);

  const loopIsDisabled = getLoopIsDisabled(showSimulationMode, userDetails);

  return (
    <div>
      {userDetails?.has_smart_tariff && loopIsDisabled && <DisabledWarning />}
      {children || <Outlet />}
    </div>
  );
};

export default EnergyFlowSavingLayoutContainer;
